<template>
  <CustomLink
    :text="$t('Lowest price guaranteed')"
    :url="priceGuaranteeUrl"
    :type="LINK_TYPE.Primary"
    class="lowest-price-guaranteed flex items-center gap-1 text-sm"
  >
    <template #front-icon>
      <span class="iconify svg--tag-empty text-EXPONDO-secondary text-base m-0.25" />
    </template>
  </CustomLink>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'LowestPriceGuaranteed',

  props: {
    priceGuaranteeUrl: {
      type: String,
      required: true,
    },
  },
  setup() {

    return { LINK_TYPE };
  
  },
});

</script>

<style lang="scss" scoped>
.lowest-price-guaranteed {
  :deep(a) {
    line-height: inherit;
  }
}
</style>
